export default __webpack_public_path__ + "static/media/us.76960df0.svg";